import { useNavigate } from 'react-router-dom';
import { useOfflineStatus } from '../lib/sync';
import { IconCloudOff, IconRefreshCw } from './icons';

// Bandeau discret affiché sous la barre du haut : invisible en ligne tant
// que la file d'attente hors-ligne (réceptions, remises, pertes, lots de
// lavage saisis sans réseau) est vide. Se montre pour signaler soit l'état
// hors-ligne, soit des actions en attente / en erreur de synchronisation —
// jamais les deux informations en même temps pour rester lisible.
export function OfflineBanner() {
  const { online, pending, errors } = useOfflineStatus();
  const navigate = useNavigate();

  if (online && !pending && !errors) return null;

  let tone: 'offline' | 'error' | 'pending' = 'pending';
  let text = `${pending} action${pending > 1 ? 's' : ''} en attente de synchronisation.`;
  if (!online) {
    tone = 'offline';
    text = 'Hors ligne — les saisies seront envoyées automatiquement au retour du réseau.';
  } else if (errors) {
    tone = 'error';
    text = `${errors} action${errors > 1 ? 's' : ''} en erreur à vérifier.`;
  }

  return (
    <div className={`offline-banner offline-banner-${tone}`}>
      <span className="offline-banner-icon">
        {tone === 'offline' ? <IconCloudOff width={16} height={16} /> : <IconRefreshCw width={16} height={16} />}
      </span>
      <span className="offline-banner-text">{text}</span>
      <button className="small" onClick={() => navigate('sync')}>Voir</button>
    </div>
  );
}
